import { createContext, useContext } from 'react';

const AppPrefixContext = createContext('/m');

export function AppPrefixProvider({ prefix, children }: { prefix: string; children: React.ReactNode }) {
  return <AppPrefixContext.Provider value={prefix}>{children}</AppPrefixContext.Provider>;
}

export function useAppPrefix() {
  return useContext(AppPrefixContext);
}
